module.exports = __webpack_public_path__ + "img/toplupe.def11dd.png";